import { useCallback } from 'react';

export const useItemSpanSize = () =>
  useCallback((index: number, itemCount: number) => {
    switch (itemCount) {
      case 1:
      case 2:
      case 3:
      case 4:
        return 24 / itemCount;
      case 5:
        return index < 3 ? 8 : 12;
      case 6:
        return 8;
      case 7:
        return index < 4 ? 6 : 8;
      case 8:
        return 6;
      default:
        return 24;
    }
  }, []);
